import { Loader } from "lucide-react";

const GlobalLoader = ({ open }: { open: boolean }) => {
  return (
    open && (
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
        <div className="p-4 bg-transparent rounded-full">
          <Loader className="animate-spin text-gray-800" size={50} />
        </div>
      </div>
    )
  );
};

export default GlobalLoader;
